module.exports = __webpack_public_path__ + "assets/img/email.0a122a45.svg";